export const API_ERROR_KINDS = [
	"notFound",
	"unauthorized",
	"forbidden",
	"internalServerError",
	"badRequest",
	"invitationConsumed",
	"unknown",
	"contentFilterTriggered",
	"timeout",
	"rateLimitExceeded",
	"noAccountFound",
	"notEnoughContent"
] as const;

export type APIErrorKind = (typeof API_ERROR_KINDS)[number];

export const API_ERROR_STATUS_CODES: Partial<Record<APIErrorKind, number>> = {
	notFound: 404,
	unauthorized: 401,
	forbidden: 403,
	internalServerError: 500,
	badRequest: 400,
	invitationConsumed: 404,
	unknown: 500,
	contentFilterTriggered: 400,
	timeout: 408,
	rateLimitExceeded: 429,
	noAccountFound: 404
};

export class APIError extends Error {
	constructor(public kind: APIErrorKind, message?: string) {
		super(message);
		this.name = `APIError:${kind}`;
	}

	toObject(includeStack: boolean = false) {
		return {
			name: this.name,
			kind: this.kind,
			message: this.message,
			stack: includeStack ? this.stack : undefined
		};
	}

	static fromObject(obj: object) {
		if (!isAPIError(obj)) throw new Error("Expected object to be an APIError");

		const apiError = new APIError(obj.kind, obj.message);
		if (obj.stack != null) apiError.stack = obj.stack;
		if (obj.name != null) apiError.name = obj.name;
		return apiError;
	}
}

export function isAPIError(error: any): error is APIError {
	return error instanceof APIError || (error.kind != null && API_ERROR_KINDS.includes(error.kind));
}
